import React from 'react'
import classNames from 'classnames'

import { useCollapsibleElement } from '_hooks'

import './styles.scss'

const SignalsCollapsible = ({ name, children, dependencies, className, resume }) => {
  const { isOpen, collapsibleHeight, collapsibleRef, TriggerCollapsible } = useCollapsibleElement([
    JSON.stringify(dependencies),
  ])

  return (
    <div
      className={classNames(
        'ac-signals-collapsible',
        { 'ac-signals-collapsible--open': isOpen },
        className
      )}
    >
      <div
        className="ac-signals-collapsible__header"
        style={{
          marginBottom: isOpen ? '16px' : '0px',
          transition: 'margin-bottom 0.3s ease-in-out',
        }}
      >
        <p>{name}</p>
        <div
          className={classNames('ac-signals-collapsible__resume', {
            'ac-signals-collapsible__resume--open': isOpen,
          })}
        >
          {resume}
        </div>
        <TriggerCollapsible />
      </div>
      <div
        className="ac-signals-collapsible__container"
        style={{ maxHeight: collapsibleHeight }}
        ref={collapsibleRef}
      >
        {children}
      </div>
    </div>
  )
}

export default SignalsCollapsible
